/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseCampaignDetailsDto } from '../../models/recourse-campaign-details-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetRecourseCampaignDetails1$Params {
  recourseCampaignId: string;
  recourseCampaignExId: string;
}

export function getRecourseCampaignDetails1(
  http: HttpClient,
  rootUrl: string,
  params: GetRecourseCampaignDetails1$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecourseCampaignDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getRecourseCampaignDetails1.PATH, 'get');
  if (params) {
    rb.path('recourseCampaignId', params.recourseCampaignId, {});
    rb.path('recourseCampaignExId', params.recourseCampaignExId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecourseCampaignDetailsDto>;
    }),
  );
}

getRecourseCampaignDetails1.PATH =
  '/service/v1/recourseCampaign/recourseCampaignDetails/{recourseCampaignId}/extendedId/{recourseCampaignExId}';
